import {analytics} from './api';
import auth from './auth';
import handleError from './error';

export default function saveEvent(name: string, payload: any) {
    payload.platform = 'app-ti';
    const event = {
        payload,
        timeZone: new Date().getTimezoneOffset(),
    };

    if(auth.isExpired()) return;
    
    analytics.save(name, event)
        .catch(err => handleError(err, null));
}